import { ShopType } from "src/utils/genderLocale/genderLocale";

export const genderTranslations = [
  "women",
  "femme",
  "damen",
  "dames",
  "kobiety",
  "mujer",
  "donna",
  "dame",
  "kvinna",
  "kids",
  "enfant",
  "kinder",
  "kids",
  "ninos",
  "bambini",
  "dzieci",
  "born",
  "barn",
  "men",
  "harren",
  "herren",
  "homme",
  "heren",
  "hombre",
  "uomo",
  "man",
  "mezczyzni",
];

export const defaultGenderLocale: Record<string, string> = {
  en: "women",
  fr: "femme",
  de: "damen",
  nl: "dames",
  pl: "kobiety",
  es: "mujer",
  it: "donna",
  "nl-be": "dames",
  "it-it": "donna",
  "es-es": "mujer",
  "pl-pl": "kobiety",
  "en-gb": "women",
};

export const genderLocaleTranslations: Record<
  Exclude<ShopType, ShopType.All>,
  Record<string, string>
> = {
  women: {
    en: "women",
    fr: "femme",
    de: "damen",
    nl: "dames",
    pl: "kobiety",
    es: "mujer",
    it: "donna",
    "nl-be": "dames",
    "it-it": "donna",
    "es-es": "mujer",
    "pl-pl": "kobiety",
    "en-gb": "women",
  },
  men: {
    en: "men",
    fr: "homme",
    de: "herren",
    nl: "heren",
    pl: "mezczyzni",
    es: "hombre",
    it: "uomo",
    "nl-be": "heren",
    "it-it": "uomo",
    "es-es": "hombre",
    "pl-pl": "mezczyzni",
    "en-gb": "men",
  },
  kids: {
    en: "kids",
    fr: "enfant",
    de: "kinder",
    nl: "kids",
    pl: "dzieci",
    es: "ninos",
    it: "bambini",
    "nl-be": "kids",
    "it-it": "bambini",
    "es-es": "ninos",
    "pl-pl": "dzieci",
    "en-gb": "kids",
  },
};

export const brandTranslations = {
  en: "brands",
  pl: "marki",
  be: "merken",
  fr: "marques",
  it: "marchi",
  de: "marken",
  nl: "merken",
  com: "brands",
  us: "brands",
  dk: "maerker",
  se: "varumarken",
  es: "marcas",
  at: "marken",
  "nl-be": "merken",
  "it-it": "marchi",
  "es-es": "marcas",
  "pl-pl": "marki",
  "de-at": "marken",
  "en-gb": "brands",
};

export const allBrandsTranslations = [
  "marques",
  "marken",
  "merken",
  "marki",
  "marcas",
  "marchi",
  "brands",
  "maerker",
  "varumarken",
];

export const kidsGenderArr = ["kids-en", "kids", "enfant", "kinder"];

export const kidsSlugs = [
  "boys-en",
  "girls-en",
  "boys",
  "girls",
  "garcon",
  "fille",
  "jungen",
  "madchen",
];
